<template>
  <LayoutSite>
    <Formulario titulo="Tipos de Pendência" v-if="!frmcadastro">
      <v-card-title>
        <v-btn color="primary" dark class="mb-2" @click="openform('novo')" :disabled="!permissoes.tipopendencia_incluir">Novo Tipo de Pendência</v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        v-model="selected"
        locale="pt-BR"
      >
        <template v-slot:item="props">
          <tr @dblclick="openform('editar',props.item.id)">
            <td class="text-xs-right">{{ props.item.nome }}</td>
            <td class="text-xs-right">{{props.item.status_descr }}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Sua Pesquisa por "{{ search }}" não encontrou registros.</v-alert>
      </v-data-table>
    </Formulario>
    <Formulario :titulo="titulo" v-if="frmcadastro">
      <v-form @submit.prevent="salvar()">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="frmcadastro=false; this.getData();">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field label="Nome" name="nome" autofocus v-model="tipo.nome"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                label="Status"
                v-model="tipo.status_id"
                :items="status"
                item-text="nome"
                item-value="id"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-alert
            dense
            outlined
            type="error"
            v-for="(erro, index) of erros"
            :key="index"
          >{{erro[0]}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed color="error" @click="confirmaExcluir()" v-if="excluir" :disabled="!permissoes.tipopendencia_excluir">EXCLUIR</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" type="submit" :disabled="!permissoes.tipopendencia_alterar">SALVAR</v-btn>
        </v-card-actions>
        <template>
          <v-row justify="center">
            <v-dialog v-model="exclusao" persistent max-width="400">
              <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>Deseja realmente excluir este Tipo de Pendência?</v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="red darken-1" text @click="exclusao = false">NÃO</v-btn>
                  <v-btn color="blue darken-1" text @click="deletar()">SIM</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-form>
    </Formulario>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";

export default {
  components: {
    LayoutSite,
    Formulario
  },
  data() {
    return {
      selected: [],
      search: "",
      headers: [
        { text: "Nome", value: "nome", align: "left" },
        { text: "Status", value: "status_descr" }
      ],
      items: [],
      frmcadastro: false,
      excluir: false,
      exclusao: false,
      readonly: true,
      titulo: String,
      status: [],
      erros: [],
      tipo: {
        id: 0,
        nome: "",
        status_id: 0
      },
      permissoes: {
        tipopendencia: false,
        tipopendencia_incluir: false,
        tipopendencia_alterar: false,
        tipopendencia_excluir: false
      }
    };
  },
  created: function() {
    this.getData();

    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.tipopendencia) this.$router.push("/#");
    }
    else
    this.$router.push("/#");
  },
  methods: {
    getData: function() {
      this.$http
        .get(this.$urlAPI + "/tipopendencia", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.items = response.data));

      this.$http
        .get(this.$urlAPI + "/status", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.status = response.data));
    },
    openform: function(opcao, id) {
      this.frmcadastro = true;
      this.erros = [];
      if (opcao == "novo") {
        this.excluir = false;
        this.titulo = "Novo Tipo de Pendência";
        this.tipo.nome = "";
        this.tipo.status_id = 0;
        this.tipo.id = 0;
      } else if (opcao == "editar") {
        this.excluir = true;
        this.titulo = "Editar Tipo de Pendência";

        this.$http
          .get(this.$urlAPI + "/tipopendencia/" + id, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            this.tipo = response.data;
          });
      }
    },
    salvar: function() {
      if (this.excluir) {
        this.$http
          .post(this.$urlAPI + "/tipopendencia/" + this.tipo.id, this.tipo, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/tipopendencia", this.tipo, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      }
    },
    confirmaExcluir: function() {
      this.exclusao = true;
    },
    deletar: function() {
      this.$http
        .delete(this.$urlAPI + "/tipopendencia/" + this.tipo.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.frmcadastro = false;
            this.exclusao = false;
            this.getData();
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    }
  }
};
</script>
